
define('text!platform/commonUI/general/res/templates/tree/tree-label.html',[],function () { return '<span class="rep-object-label">\n    <div class="t-object-label l-flex-row flex-elem grows">\n        <div class="t-item-icon flex-elem"></div>\n        <div class=\'t-title-label flex-elem grows\'></div>\n    </div>\n</span>\n';});

